<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    :subtitle="connectedService.name"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="60%"
  >
    <v-tabs centered v-model="selectedTab">
      <v-tab>{{ $t("General") }}</v-tab>
      <v-tab>{{ $t("Settings") }}</v-tab>
      <v-tab-item>
        <v-card flat class="my-0">
          <v-card-text>
            <v-select
              v-model="connectedService.serviceName"
              v-bind:label="$t('Service')"
              :items="serviceList"
              item-text="ServiceName"
              item-value="ServiceName"
              :error-messages="serviceNameErrors"
              @change="updateServiceParams"
              @blur="$v.connectedService.serviceName.$touch()"
            ></v-select>
            <v-text-field
              v-bind:label="$t('Description')"
              v-model="connectedService.description"
              :error-messages="descriptionErrors"
              @input="$v.connectedService.description.$touch()"
              @blur="$v.connectedService.description.$touch()"
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="my-0">
          <v-card-text>
            <div v-for="(param, index) in connectedService.params" :key="index">
              <v-text-field
                :label="param.label"
                v-model="param.value"
                :error-messages="requiredFieldErrors(index)"
              ></v-text-field>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </base-modal>
</template>
<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

import ConnectedServiceService from "@/services/ConnectedServiceService";
import ConnectedService from "@/ecm/models/connectedService/ConnectedService";
import Utils from "@/ecm/common/Utils";

export default {
  name: "ConnectedServiceModal",
  created() {
    ConnectedServiceService.getList().then((data) => {
      this.serviceList = data;
    });
  },
  data() {
    return {
      serviceList: [],
      modal: {
        title: this.$t("ConnectedService"),
        key: "connectedServiceModal",
      },
      open: false,
      connectedService: new ConnectedService(),
      selectedTab: 0,
      isNew: true,
    };
  },
  mixins: [validationMixin],
  validations: {
    connectedService: {
      serviceName: { required },
      description: { required },
      params: {
        $each: {
          value: {
            required: requiredIf(function (model) {
              return model.isRequired;
            }),
          },
        },
      },
    },
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    modalTitle() {
      return (
        this.modal.title +
        (this.connectedService.description
          ? " - " + this.connectedService.description
          : "")
      );
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.connectedService.description.$dirty) return errors;
      !this.$v.connectedService.description.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    serviceNameErrors() {
      const errors = [];
      if (!this.$v.connectedService.serviceName.$dirty) return errors;
      !this.$v.connectedService.serviceName.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
  },
  methods: {
    requiredFieldErrors(index) {
      const errors = [];
      if (!this.$v.connectedService.params.$each[index].value.$dirty)
        return errors;
      !this.$v.connectedService.params.$each[index].value.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    saveItem() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        if (
          this.$v.connectedService.description.$invalid ||
          this.$v.connectedService.serviceName.$invalid
        ) {
          this.selectedTab = 0;
        } else {
          this.selectedTab = 1;
        }
        return;
      }

      this.modalInstance.progress(true);

      ConnectedServiceService.save(this.connectedService.toDto())
        .then((result) => {
          if (result) {
            if (this.isNew) {
              Utils.toast.success(
                this.$t("ConnectedService") + " " + this.$t("CreatedSuccessfully")
              );
            } else {
              Utils.toast.success(
                this.$t("ConnectedService") + " " + this.$t("UpdatedSuccessfully")
              );
            }
            this.hide();
            this.$emit("on-item-saved");
          }
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    new() {
      this.selectedTab = 0;
      this.connectedService = new ConnectedService();
      this.$v.$reset();
      this.show();
    },
    edit(dto) {
      this.selectedTab = 1;
      this.isNew = false;
      var defaultParams = this.serviceList.find(
        (x) => x.ServiceName == dto.ServiceName
      ).Params;
      defaultParams.forEach((param) => {
        var dtoParam = dto.Params.find((x) => x.ParamName == param.ParamName);
        if (dtoParam) {
          param.ParamValue = dtoParam.ParamValue;
        }
      });
      dto.Params = defaultParams;
      this.connectedService = new ConnectedService(dto);
      this.$v.$reset();
      this.show();
    },
    updateServiceParams(serviceName) {
      var service = this.serviceList.find((x) => x.ServiceName == serviceName);
      this.connectedService = new ConnectedService(service);
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
      this.isNew = true;
    },
  },
};
</script>
